type Nullable<T> = T | null;

export type ContentPlatformTemplateImageAsset = {
    title: string;
    description: Nullable<string>;
    url: string;
    details: object;
    fileName: string;
    contentType: string;
};

export type ContentPlatformTaxonomyIndustry = {
    name: Nullable<string>;
    shortDescription: Nullable<string>;
};

export type ContentPlatformOrganization = {
    __typename: "ContentPlatformOrganization";
    name: string;
    tagline: Nullable<string>;
    logo: Nullable<ContentPlatformTemplateImageAsset[]>;
    shortDescription: Nullable<string>;
    industry: Nullable<ContentPlatformTaxonomyIndustry[]>;
};

export type ContentPlatformAuthor = {
    __typename: "ContentPlatformAuthor";
    name: string;
    jobTitle: Nullable<string>;
    authorPicture: Nullable<ContentPlatformTemplateImageAsset>;
    organization: Nullable<ContentPlatformOrganization>;
    shortBiography: Nullable<string>;
};

export type ContentPlatformOrganizationAndAuthorUnion =
    | ContentPlatformOrganization
    | ContentPlatformAuthor;

export type ContentPlatformTemplateUseStep = {
    name: string;
    description: Nullable<object>;
    asset: Nullable<ContentPlatformTemplateImageAsset>;
};

export type ContentPlatformTemplateGuide = {
    name: string;
    steps: Nullable<ContentPlatformTemplateUseStep[]>;
};

export type ContentPlatformCategory = {
    id: string;
    name: Nullable<string>;
    urlSlug: Nullable<string>;
    shortDescriptionOneLiner: Nullable<string>;
    description: Nullable<object>;
};

export type ContentPlatformTaxonomyUserRoleNew = {
    roleDescription: string;
    userRole: string;
    userRoleId: string;
};

export type ContentPlatformTaxonomyCompanySize = {
    name: string;
    shortDescription: string;
};

export type ContentPlatformTemplateCollectionStep = {
    id: string;
    name?: Nullable<string>;
    stepSubheading?: Nullable<string>;
    stepDescription: Node;
    relatedTemplate?: Nullable<ContentPlatformTemplate>;
};

export type ContentPlatformTemplateCollectionGuide = {
    id: string;
    name?: Nullable<string>;
    collectionSteps?: Nullable<ContentPlatformTemplateCollectionStep[]>;
};

export type ContentPlatformTemplate = {
    templateId: string;
    name: Nullable<string>;
    contributor: Nullable<ContentPlatformOrganizationAndAuthorUnion>;
    previewBlurb: Nullable<string>;
    templateIcon: Nullable<ContentPlatformTemplateImageAsset>;
    templatePreview: Nullable<ContentPlatformTemplateImageAsset[]>;
    oneLinerHeadline: Nullable<string>;
    aboutThisTemplate: object;
    howToUseThisTemplate: ContentPlatformTemplateGuide[];
    category: Nullable<ContentPlatformCategory[]>;
    relatedTemplates: Nullable<ContentPlatformTemplate[]>;
    targetAudience: Nullable<ContentPlatformTaxonomyUserRoleNew[]>;
    targetOrganizationSize: Nullable<ContentPlatformTaxonomyCompanySize[]>;
};

export type ContentPlatformTemplateCollection = {
    collectionId: string;
    name: Nullable<string>;
    urlSlug: Nullable<string>;
    collectionIcon: Nullable<ContentPlatformTemplateImageAsset>;
    oneLinerHeadline: Nullable<string>;
    aboutThisCollectionHeader?: Nullable<string>;
    aboutThisCollection?: Nullable<string>;
    aboutThisCollectionImage?: Nullable<ContentPlatformTemplateImageAsset>;
    howToUseThisCollection?: Nullable<ContentPlatformTemplateCollectionGuide>;
    targetAudience: Nullable<ContentPlatformTaxonomyUserRoleNew[]>;
    targetOrganizationSize: Nullable<ContentPlatformTaxonomyCompanySize[]>;
};

export type PageInfo = {
    hasNextPage: boolean;
    endCursor: string;
};

export type ContentPlatformTemplateResultEdge = {
    node: ContentPlatformTemplate;
    cursor: string;
};

export type ContentPlatformTemplateContentSearchConnection = {
    pageInfo: PageInfo;
    edges: ContentPlatformTemplateResultEdge[];
};

export type AGGQueryResponse = {
    data: {
        templates: ContentPlatformTemplateContentSearchConnection;
    };
};
